module.exports = __webpack_public_path__ + "static/paige-814f9e41093db776708db0d46d193dc9.jpg";